import { Input } from "src/styles/input";
import styled from "styled-components";

export const FilterContainer = styled.div`
  padding: 8px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  max-height: 300px;
`;

export const SearchInput = styled(Input)`
  width: 100%;
  flex-shrink: 0;
`;

export const FilterList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
  min-height: 0;
`;

export const FilterItem = styled.li`
  display: flex;
  align-items: baseline;
  margin: 8px 0;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const FilterLabel = styled.span`
  margin-left: 0px;
  flex: 1;
`;
